import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricImprShareFromEligImprBing extends MetricBase {
    constructor() {
        super({
            field: "metric_impr_share_from_elig_impr",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.imprShareFromEligImpr.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.imprShareFromEligImpr.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.imprShareFromEligImpr.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricImprShareFromEligImprBing;
